import { useEffect, useState } from "react";
import api from "@/lib/api";

const ACTIVITY_LABELS = {
  auto_locksmith: "Serrurerie automobile",
  detailing: "Nettoyage / detailing",
  tint: "Films teintés",
  garage: "Garage / entretien",
  other: "Autre",
};
const GOAL_LABELS = { collect: "Recueil d'infos", quote: "Devis", book: "Réservation", other: "Autre" };
const PRICING_LABELS = { fixed: "Forfaits fixes", grid: "Grille tarifaire", case: "Cas par cas", help: "Accompagnement" };
const WEBSITE_LABELS = { yes: "Oui", no: "Non", in_progress: "En cours" };

function fmt(iso) {
  try { const d = new Date(iso); return d.toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" }); }
  catch { return iso; }
}

export default function MtgLeads() {
  const [items, setItems] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/mtg-leads")
      .then((r) => setItems(r.data))
      .catch((e) => setError(e?.response?.data?.detail || "Accès refusé."));
  }, []);

  if (error) {
    return (
      <div className="max-w-2xl">
        <h1 className="font-display text-3xl font-extrabold text-[#16324F]">Prospects MonTempsGagné</h1>
        <div className="mt-6 rounded-xl bg-[#FF7A59]/10 border border-[#FF7A59]/30 text-[#8A2E14] text-sm px-4 py-3">
          {error}
        </div>
      </div>
    );
  }

  if (items === null) {
    return <div className="text-slate-500">Chargement…</div>;
  }

  return (
    <div>
      <div className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <h1 className="font-display text-3xl font-extrabold text-[#16324F]">Prospects MonTempsGagné</h1>
          <p className="mt-1 text-sm text-slate-500">Demandes de professionnels intéressés par la solution MonTempsGagné.</p>
        </div>
        <div className="text-sm text-slate-500" data-testid="mtg-leads-count">{items.length} demande{items.length > 1 ? "s" : ""}</div>
      </div>

      {items.length === 0 ? (
        <div className="mt-8 rounded-2xl bg-white border border-slate-100 p-8 text-center text-slate-500">
          Aucune demande reçue pour le moment.
        </div>
      ) : (
        <div className="mt-6 grid gap-4">
          {items.map((it) => (
            <div key={it.id} className="bg-white rounded-2xl border border-slate-100 p-5" data-testid={`mtg-lead-${it.id}`}>
              <div className="flex items-start justify-between gap-4 flex-wrap">
                <div>
                  <div className="text-xs text-slate-400">{fmt(it.created_at)}</div>
                  <div className="mt-1 font-display text-lg font-bold text-[#16324F]">{it.name}</div>
                  <div className="text-sm text-slate-500">{it.email}{it.company ? ` · ${it.company}` : ""}</div>
                </div>
                <span className={`inline-flex items-center gap-1.5 rounded-full text-[10px] font-bold uppercase tracking-widest px-2.5 py-1 ${it.result === "quote" ? "bg-[#19C3B3]/15 text-[#0E5A56]" : "bg-[#FF7A59]/10 text-[#8A2E14]"}`}>
                  {it.result === "quote" ? "Devis généré" : "Projet à étudier"}
                </span>
              </div>

              <dl className="mt-4 grid sm:grid-cols-2 gap-x-6 gap-y-2 text-sm">
                <div className="flex justify-between gap-4"><dt className="text-slate-500">Activité</dt><dd className="font-semibold text-[#16324F] text-right">{it.activity === "other" ? (it.activity_other || "Autre") : (ACTIVITY_LABELS[it.activity] || it.activity)}</dd></div>
                <div className="flex justify-between gap-4"><dt className="text-slate-500">Tarification</dt><dd className="font-semibold text-[#16324F] text-right">{PRICING_LABELS[it.pricing_style] || it.pricing_style}</dd></div>
                <div className="flex justify-between gap-4"><dt className="text-slate-500">Automatisations</dt><dd className="font-semibold text-[#16324F] text-right">{(it.goals || []).filter((c) => c !== "other").map((c) => GOAL_LABELS[c] || c).concat((it.goals || []).includes("other") ? [it.goals_other || "Autre"] : []).join(" · ") || "—"}</dd></div>
                <div className="flex justify-between gap-4"><dt className="text-slate-500">Site internet</dt><dd className="font-semibold text-[#16324F] text-right">{WEBSITE_LABELS[it.has_website] || it.has_website}{it.website_url ? ` · ${it.website_url}` : ""}</dd></div>
              </dl>

              {it.notes && (
                <div className="mt-4 rounded-xl bg-[#F6F9FC] border border-[#EAF1F7] p-3">
                  <div className="text-xs font-bold uppercase tracking-widest text-slate-500">Précisions</div>
                  <div className="mt-1 text-sm text-[#16324F] whitespace-pre-wrap">{it.notes}</div>
                </div>
              )}

              <div className="mt-3 text-xs text-slate-400">
                E-mail prospect : <span className="font-semibold">{it.email_status_lead || "—"}</span>
                {it.email_status_admin && <> · Notification admin : <span className="font-semibold">{it.email_status_admin}</span></>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
